import {type BottomSheetViewProps} from './BottomSheet.types'

export function BottomSheetNativeComponent(_: BottomSheetViewProps) {
  throw new Error('BottomSheetNativeComponent is not available on web')
}
